// src/contexts/TextAreaContext.tsx
import React, { useState, useCallback } from 'react';
import { TextAreaContext, type TextAreaType } from './context';

export const TextAreaProvider: React.FC<{ children: React.ReactNode }> = ({
  children,
}) => {
  const [focusedTextArea, setFocusedTextArea] =
    useState<TextAreaType>('textbox');
  const [inputText, setInputText] = useState<string>('');
  const [clearChatTrigger, setClearChatTrigger] = useState<boolean>(false);

  const [defaultHandler, setDefaultHandler] = useState<(text: string) => void>(
    () => () => {}
  );

  const insertText = useCallback(
    (text: string) => {
      defaultHandler(text);
    },
    [focusedTextArea, defaultHandler]
  );

  const setInsertTextHandler = (handler: (text: string) => void) => {
    setDefaultHandler(() => handler);
  };

  return (
    <TextAreaContext.Provider
      value={{
        inputText,
        clearChatTrigger,
        focusedTextArea,
        setFocusedTextArea,
        insertText,
        setInsertTextHandler,
        setInputText,
        setClearChatTrigger,
      }}
    >
      {children}
    </TextAreaContext.Provider>
  );
};
